import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface ComplaintDetailModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ComplaintDetail({ open, onClose, setOpen }: ComplaintDetailModalProps) {
  return (
    <Modal
      className="modal complaintDetail_modal"
      id="complaintDetailModal"
      aria-labelledby="complaintDetail-modal-title"
      aria-describedby="complaintDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Complaint Detail</h2>
            <p>Lorem ipsum dummy text</p>
          </div>
          <div className="complaint_reason">
            <p>
              Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into electronic typesetting,
              remaining essentially unchanged. It was popularised in the 1960s with the release of
              Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </p>
            <p>
              It is a long established fact that a reader will be distracted by the readable content
              of a page when looking at its layout. The point of using Lorem Ipsum is that it has a
              more-or-less normal distribution of letters, as opposed to using 'Content here,
              content here', making it look like readable English.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
